/**
 * Where the RAM list in `state.users.ramUsers` is read from. Decided once per
 * session by `ensureManagerListSources` and kept in
 * `state.users.managerListSources`.
 *
 * @enum {string}
 */
export const RamUsersSource = {
  SalesMetros: 'salesMetros',
  Monolith: 'monolith',
};

/**
 * Where the RAM filters' "no metro" option comes from while sales metros fill
 * `state.users.ramUsers`: the list's own reserved Unassigned row, sent as its
 * all-zeros id, or the portal's `'unassigned'` sentinel. Always the sentinel
 * while the monolith fills the list, which has no such row.
 *
 * @enum {string}
 */
export const UnassignedMetroSource = {
  SalesMetro: 'metro',
  Sentinel: 'sentinel',
};
